import { usePiniaManager } from 'composables/pinia-manager';
import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { RequestManager } from '@jaseeey/request-manager';

export const useJobShortlistStore = defineStore('job-shortlist', () => {

    const piniaManager = usePiniaManager();

    const shortlistedJobs = ref([]);

    const isLoading = ref(false);
    const isLoaded = ref(false);
    const lastPage = ref(0);
    const lastLimit = ref(20);
    const totalPages = ref(0);

    const hasMoreShortlistedJobs = computed(() => lastPage.value < totalPages.value);

    async function loadShortlistedJobs(page = 1, limit = 20, overwrite = true) {
        try {
            isLoading.value = true;
            const options = {
                params: { page, limit }
            };
            await RequestManager.call(this.$api, 'get', '/user/shortlists', {}, options, res => {
                if (overwrite) {
                    shortlistedJobs.value = [];
                }
                shortlistedJobs.value.push(...res.data);
                isLoaded.value = true;
                lastPage.value = page;
                lastLimit.value = limit;
                totalPages.value = parseInt(res.headers['x-filter-total-pages'], 10);
            });
        }
        finally {
            isLoading.value = false;
        }
    }

    async function loadMoreShortlistedJobs() {
        if (!hasMoreShortlistedJobs.value) {
            return;
        }
        await loadShortlistedJobs(lastPage.value + 1, lastLimit.value, false);
    }

    async function createShortlistedJob(jobScopeId) {
        const newShortlistedJob = (await this.$api.post('/user/shortlists', { jobScopeId })).data;
        shortlistedJobs.value.unshift(newShortlistedJob);
        return newShortlistedJob;
    }

    async function deleteShortlistedJob(jobScopeId) {
        await this.$api.delete(`/user/shortlists/${jobScopeId}`);
        const loadedIndex = shortlistedJobs.value.findIndex(sj =>
            sj.scopes.some(s => s.id === jobScopeId)
        );
        if (loadedIndex !== -1) {
            shortlistedJobs.value.splice(loadedIndex, 1);
        }
    }

    piniaManager.onSessionTerminated(() => {
        shortlistedJobs.value = [];
        isLoading.value = false;
        isLoaded.value = false;
        lastPage.value = 0;
        lastLimit.value = 20;
        totalPages.value = 0;
    });

    return {
        shortlistedJobs,
        isLoading,
        isLoaded,
        hasMoreShortlistedJobs,
        loadShortlistedJobs,
        loadMoreShortlistedJobs,
        createShortlistedJob,
        deleteShortlistedJob
    };
});
